export function CalendarTick({ className }: { className?: string }) {
    return (
      <svg
        className={className}
        width="1em"
        height="1em"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Group 1000002151">
          <path
            id="Vector"
            d="M4.88696 10.0417L7.27845 11.7919L11.4636 7.1246"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_2"
            d="M2.19575 2.74835C1.87861 2.74835 1.57447 2.87128 1.35022 3.0901C1.12598 3.30892 1 3.60571 1 3.91517V13.8332C1 14.1426 1.12598 14.4395 1.35022 14.6582C1.57447 14.877 1.87861 15 2.19575 15H14.1532C14.4703 15 14.7745 14.877 14.9987 14.6582C15.2229 14.4395 15.3489 14.1426 15.3489 13.8332V3.91517C15.3489 3.60571 15.2229 3.30892 14.9987 3.0901C14.7745 2.87128 14.4703 2.74835 14.1532 2.74835H2.19575Z"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_3"
            d="M3.98999 1V4.50047"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Vector_4"
            d="M12.3589 1V4.50047"
            stroke="currentcolor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
    );
  }
  